import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";


export const TitleStyles = muiStyled(Box)(({ breadcrumbs, theme }) => ({
    'h1': {
        height: 23,
        fontSize: 19,
        padding: 0,
        margin: 0,
        display: "flex",
        columnGap: 5,
        alignItems: "center",
    },
    '.title': {
        cursor: breadcrumbs && "pointer",
        ':hover': {
            opacity: breadcrumbs && 0.7
        }
    },
    '.bread-crumbs-title': {
        display: "flex",
        columnGap: 5,
        alignItems: "center",
    }
}))
